/**
 * DecisionBadge — Color-coded badge for PRE decisions
 *
 * ALLOW → emerald/success
 * ALLOW_WITH_CONDITIONS → amber/warning
 * BLOCK → red/error
 */
import { Badge } from '@respectly/ui';
import type { PREDecision } from '@respectly/shared-types';

const DECISION_CONFIG: Record<
  PREDecision,
  { label: string; variant: 'success' | 'warning' | 'error' }
> = {
  ALLOW: { label: 'Allow', variant: 'success' },
  ALLOW_WITH_CONDITIONS: { label: 'Conditional', variant: 'warning' },
  BLOCK: { label: 'Block', variant: 'error' },
};

interface DecisionBadgeProps {
  decision: PREDecision;
  className?: string;
}

export function DecisionBadge({ decision, className }: DecisionBadgeProps) {
  const config = DECISION_CONFIG[decision];
  return (
    <Badge variant={config.variant} className={className}>
      {config.label}
    </Badge>
  );
}
